import React, { lazy, Suspense } from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';
import Loading from 'helpers/loading/loading';

const Component = lazy(async () => {
  const { CompanyOauthClients: LoadedComponent } = await import('components/company-oauth-clients');
  return { default: LoadedComponent };
});

const CompanyOauthClients = (props) => (
  <CWOConfigProvider>
    <Suspense fallback={<Loading />}>
      <Component {...props} />
    </Suspense>
  </CWOConfigProvider>
);

export default CompanyOauthClients;
